





















































import { Component, Prop, Vue } from "vue-property-decorator";

import DatePicker from "@/components/DatePicker.vue";
import TimeSlotPicker, { SlotObject } from "@/components/TimeSlotPicker.vue";
import VCheckbox from "@/components/VCheckbox.vue";

@Component({
  components: {
    DatePicker,
    TimeSlotPicker,
    VCheckbox,
  },
})
export default class SingleReport extends Vue {
  @Prop({ default: undefined }) readonly startsAt?: string;
  @Prop({ default: undefined }) readonly endsAt?: string;
  @Prop({ default: undefined }) readonly compareStartsAt?: string;
  @Prop({ default: undefined }) readonly compareEndsAt?: string;
  @Prop({ default: "" }) readonly maxDate!: string;
  @Prop({ default: false }) readonly isVodOnly!: boolean;
  @Prop({ default: () => [] }) readonly timeSlots!: SlotObject[];
  @Prop({ default: false }) readonly timeSlotsEnabled!: boolean;
  @Prop({ default: false }) readonly compare!: boolean;

  get periodDatePicker(): DatePicker | undefined {
    return this.$refs.periodDatePicker as DatePicker | undefined;
  }

  get compareDatePicker(): DatePicker | undefined {
    return this.$refs.compareDatePicker as DatePicker | undefined;
  }
}
